export default {
    ws: {},
    setWs: function(newWs) {
        this.ws = newWs
    }
}
